import { Master } from './master';

export class FaturaKalem {

  id: number;
  stokKodu: string;
  stokAdi: string;
  ekAlan: string;
  miktar: number;
  olcuBirimi: string;
  birimFiyat: number;
  paraBirimiId: number;
  kdvOrani: number;
  muhasebeKodu: string;
  sarfYeriId: number;
  grupKodu: string;
  kod1: string;

  sarfYeri: Master = null;
  paraBirimi: Master = null;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
    if (obj.sarfYeri != null) {
      this.sarfYeri = new Master(obj.sarfYeri);
    }
    if (obj.paraBirimi != null) {
      this.paraBirimi = new Master(obj.paraBirimi);
    }
  }
}
